



































import { toRefs, computed, defineComponent, PropType, ComputedRef } from '@vue/composition-api'
import store from '@/store'
import { Section } from '@shared/sm/sections/types'
import { Term } from '@shared/sm/general/terms/types'
import { MeetingPattern } from '@shared/sm/sections/subdomains/meetingPatterns/types'
import { Questions } from '@shared/sm/general/sectionTemplate/subdomains/questions/types'

export default defineComponent({
  name: 'MeetingPatternsDetailsModal',
  components: {
    FormFieldsRow: () => import('@/components/Forms/FormFieldsRow.vue'),
    MeetingPatternForm: () => import('@sm/client/components/SchedulingManagement/sections/subdomains/meetingPatterns/MeetingPatternForm.vue'),
  },
  props: {
    formValue: {
      type: Object as PropType<Section>,
      required: true,
    },
    questions: {
      type: Object as PropType<Questions>,
      required: true,
    },
  },
  setup (props, { emit }) {
    const { formValue } = toRefs(props)

    const times: ComputedRef<MeetingPattern[]> = computed(() => formValue.value.times)
    const viewingTermObject: ComputedRef<Term> = computed(() => store.getters.viewingTermObject)

    function update (meetingPattern: MeetingPattern, mpIndex: number) {
      const newValue: MeetingPattern[] = [
        ...formValue.value.times.slice(0, mpIndex),
        meetingPattern,
        ...formValue.value.times.slice(mpIndex + 1),
      ]

      emit('input', newValue)
    }

    function close () {
      emit('close')
    }

    return {
      times,
      term: viewingTermObject,
      update,
      close,
    }
  },
})
